import { render, staticRenderFns } from "./EditSchoolUser.vue?vue&type=template&id=32f5dcf6&"
import script from "./EditSchoolUser.vue?vue&type=script&lang=js&"
export * from "./EditSchoolUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports